import { NotificationDialogComponent } from './../notification/notification.dialog.component';
import { DialogService } from 'ng2-bootstrap-modal';
import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';

import { environment } from '../../environments/environment';
import { APIURLS } from '../_constants/constants';
import { SHAREDCONSTANTS } from './../_constants/constants';
import { AgentProfile } from './../_models/agent.profile';
import { AgentProfileLastLogin } from './../_models/agent.profile';

import { TranslateService } from '../_services/translate.service';
import { TranslatePipe } from '../shared/translate/translate.pipe';
import { LoaderService } from '../_services/loader.service';


@Injectable()
export class AgentProfileService {
    private agentProfile: AgentProfile;
    private agentProfileLastLogin : AgentProfileLastLogin;
    // private teams = [
    //     { "key": "sq_AL", "value": "Albanian (Albania)"},
    //     { "key": "nl_NL", "value": "Dutch (Netherlands)" },
    //     { "key": "en_IE", "value": "English (Ireland)" },
    //     { "key": "en_ZA", "value": "Albanian (Albania)" },
    //     { "key": "en_GB", "value": "Albanian (Albania)" },
    //     { "key": "de_DE", "value": "Albanian (Albania)" },
    //     { "key": "el_GR", "value": "Albanian (Albania)" },
    //     { "key": "hu_HU", "value": "Albanian (Albania)" },
    //     { "key": "is_IS", "value": "Albanian (Albania)" },
    //     { "key": "it_IT", "value": "Albanian (Albania)" },
    //     { "key": "mt_MT", "value": "Albanian (Albania)" },
    //     { "key": "pt_PT", "value": "Albanian (Albania)" },
    //     { "key": "ro_RO", "value": "Albanian (Albania)" },
    //     { "key": "es_ES", "value": "Albanian (Albania)" }
    // ];


    private teams = [
        { "key": "AL", "value": "Albanian (Albania)"},
        { "key": "NL", "value": "Dutch (Netherlands)" },
        { "key": "IE", "value": "English (Ireland)" },
        { "key": "ZA", "value": "English (South Africa)" },
        { "key": "GB", "value": "English (United Kingdom)" },
        { "key": "DE", "value": "German (Germany)" },
        { "key": "GR", "value": "Greek (Greece)" },
        { "key": "HU", "value": "Hungarian (Hungary)" },
        { "key": "IS", "value": "Icelandic (Iceland)" },
        { "key": "IT", "value": "Italian (Italy)" },
        { "key": "MT", "value": "Maltese (Malta)" },
        { "key": "PT", "value": "Portugese (Portugal)" },
        { "key": "RO", "value": "Romanian (Romania)" },
        { "key": "ES", "value": "Spanish (Spain)" },
        { "key": "IN", "value": "Hindi (India)" }
    ];
    private Zonelist = [
        
        { "key": "(UTC+2) Athens Bucharest", "value": "Europe/Bucharest"},
        
    ];

    constructor(private router: Router, 
        private http: Http, 
        private ds: DialogService, 
        private translate: TranslateService, 
        private loaderService: LoaderService) {

       // this.loadAgentLastLoginDetails();
        this.loadAgentProfileInitial();
    }

    // For testing purpose not private, the agentprofile is a special service, which needs to load the data in constructor,
    // but karma isn't able to mock the route before the service provider is created, so it will always be undefined
    loadAgentProfileInitial() {
        this.loaderService.display(true);
        document.cookie = 'XSRF-TOKEN=' + this.generateRandomXSRFToken();
        const URL = (environment.BASE_URL_BACKEND + APIURLS.AGENT);
        const headers = new Headers();
        headers.append('Accept', 'application/json; charset=utf-8');
        headers.append('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');
        headers.append('Cache-Control', 'no-cache');
        headers.append('Pragma', 'no-cache');
        const options = new RequestOptions({ headers: headers, withCredentials: true });
        this.http.get(URL, options).subscribe(
            (data) => {
                const agentProfile: AgentProfile = data.json();
                this.agentProfile = new AgentProfile(agentProfile);                               
                const enableLocalization = true;//data.json().enableLocalization;
                localStorage.setItem('localized',JSON.stringify(enableLocalization));
                
                //document.cookie = 'X-CSRF-TOKEN=' + data.headers.get("X-CSRF-TOKEN");

               this.loaderService.display(false);

                this.loadEnableTeams();

                this.agentProfile.permissionError = new TranslatePipe(this.translate).transform('FORBIDDEN', 'API_ERROR');

            }, err => {
                if (err.status === 404 && (err.json().message.toLowerCase().indexOf('roles') !== -1
                    || err.json().message.toLowerCase().indexOf('constraint') !== -1)) {
                    this.ds.addDialog(NotificationDialogComponent, {
                        success: false,
                        message: new TranslatePipe(this.translate).transform('AGENT_USER_RGHT_ERROR_MESSAGE','SHAREDCONSTANTS')
                    });
                } else {
                    if (err.json().redirectUri) {
                        window.location.href = err.json().redirectUri;
                    } else {
                        
                        if(err.json().internalCode && this.translate.checkAPIErrorExistsByCode(err.json().internalCode)){
                            this.ds.addDialog(NotificationDialogComponent, {
                                success: false,
                                message: new TranslatePipe(this.translate).transform(err.json().internalCode,'API_ERROR')                   
                            });
                        }
                        else{
                            this.ds.addDialog(NotificationDialogComponent, {
                                success: false,
                                message: new TranslatePipe(this.translate).transform('COMMON_ERROR_MESSAGE','SHAREDCONSTANTS')
                            });
                        }

                        // this.ds.addDialog(NotificationDialogComponent, {
                        //     success: false,
                        //     message: new TranslatePipe(this.translate).transform('REDIRECT_URL_ERROR','SHAREDCONSTANTS')
                        // });
                    }
                }

                if(err.status === 401){
                    console.log("session logout");
                    localStorage.setItem('searchData',JSON.stringify({}));
                    localStorage.setItem('language',"");
                    localStorage.setItem('opco-header',"");
                    localStorage.setItem('opco',"");
                    localStorage.setItem('country',"");
                    localStorage.setItem('localized',"");
                }

               // this.loaderService.display(false);
            }
        );
    }

    private generateRandomXSRFToken(): string {
        let text = '';
        const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const length = 33;
        for (let i = 0; i < length; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
    }

    loadAgentProfile(): AgentProfile {
        return this.agentProfile;
    }

    updatePermissionError(msg):any {
        this.agentProfile.permissionError = msg;
    }


    loadAgentLastLoginDetails(){
        this.loaderService.display(true);
        
        const URL = (environment.BASE_URL_BACKEND + APIURLS.AGENT_LASTLOGIN);
        const headers = new Headers();
        headers.append('Accept', 'application/json; charset=utf-8');
        headers.append('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');
        headers.append('Cache-Control', 'no-cache');
        headers.append('Pragma', 'no-cache');
        const options = new RequestOptions({ headers: headers, withCredentials: true });
        this.http.get(URL, options).subscribe(
            (data) => {
                const agentProfileLastLogin: AgentProfileLastLogin = data.json();
                this.agentProfileLastLogin = new AgentProfileLastLogin(agentProfileLastLogin);
            }, err => {

            }
        );
    }

    fetchLastLoginDetails(): AgentProfileLastLogin {
        return this.agentProfileLastLogin;
    }

    lastSuccessFulLoginDetail(): any {
        return this.agentProfile.lastSuccessFulLoginDetail;
    }

    getAAAUrl(): any {
        return this.agentProfile.aaaMyAccountUrl;
    }

    loadEnableTeams(){

    }

    getTeams(){
        return this.teams;
    }
    getZoneLIst(){
        return this.Zonelist;
    }

}



// WEBPACK FOOTER //
// ./src/app/_services/agent.profile.service.ts